var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49.968 -295.968)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    transform: "translate(49.968 295.968)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 297.531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.032,27.285H1.658A.648.648,0,0,0,1,27.924V45.846a.648.648,0,0,0,.656.64H27.751a.64.64,0,1,0,0-1.28H2.315V28.565H39.372v1.6a.648.648,0,0,0,.656.64h0a.648.648,0,0,0,.658-.638V27.925A.648.648,0,0,0,40.032,27.285Z",
    transform: "translate(-1 -13.29)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.875,16.06l-30.7-6.72a.676.676,0,0,0-.5.084.644.644,0,0,0-.29.4l-1.535,6.72a.64.64,0,0,0,.5.764.658.658,0,0,0,.785-.486l1.391-6.094,30.055,6.579a.639.639,0,0,0,.145.016.638.638,0,0,0,.144-1.264Z",
    transform: "translate(-2.305 -4.84)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.315,8.544,21.9,1.077a.668.668,0,0,0-.844.305L19.517,4.369a.633.633,0,0,0,.267.87.669.669,0,0,0,.894-.259c.007-.012.013-.025.019-.037h0l1.259-2.452,17.85,7.236a.666.666,0,0,0,.863-.345A.636.636,0,0,0,40.315,8.544Z",
    transform: "translate(-9.473 -1.027)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.192,32.812H47.1a.64.64,0,1,0,0,1.28h6.091a.64.64,0,1,0,0-1.28Z",
    transform: "translate(-21.884 -15.77)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.556,32.891a6.573,6.573,0,1,0,6.754,6.571A6.664,6.664,0,0,0,30.556,32.891Zm0,11.947a5.378,5.378,0,1,1,5.526-5.376A5.452,5.452,0,0,1,30.556,44.838Z",
    transform: "translate(-11.479 -15.86)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.2,36.759c-4.067,0-8.442.935-8.442,2.987V57.667c0,2.052,4.374,2.987,8.442,2.987s8.442-.935,8.442-2.987V39.746C71.642,37.694,67.267,36.759,63.2,36.759Zm6.907,20.9c-.116.414-2.417,1.5-6.907,1.5s-6.791-1.09-6.907-1.493V56.493A17.328,17.328,0,0,0,63.2,57.667a17.379,17.379,0,0,0,6.907-1.175Zm0-2.987c-.116.414-2.417,1.5-6.907,1.5s-6.791-1.09-6.907-1.493V53.506A17.328,17.328,0,0,0,63.2,54.68a17.379,17.379,0,0,0,6.907-1.175Zm0-2.987c-.116.414-2.417,1.5-6.907,1.5s-6.791-1.09-6.907-1.493V50.52A17.329,17.329,0,0,0,63.2,51.693a17.379,17.379,0,0,0,6.907-1.175Zm0-2.987c-.116.414-2.417,1.5-6.907,1.5s-6.791-1.09-6.907-1.493V47.533A17.329,17.329,0,0,0,63.2,48.707a17.379,17.379,0,0,0,6.907-1.175Zm0-2.987c-.116.414-2.417,1.5-6.907,1.5s-6.791-1.09-6.907-1.493V44.546A17.394,17.394,0,0,0,63.2,45.72a17.378,17.378,0,0,0,6.907-1.175Zm0-2.987c-.116.414-2.417,1.5-6.907,1.5s-6.791-1.09-6.907-1.493V41.559A17.394,17.394,0,0,0,63.2,42.733a17.379,17.379,0,0,0,6.907-1.175ZM63.2,41.24c-4.483,0-6.783-1.087-6.907-1.48v0c.124-.416,2.424-1.5,6.907-1.5,4.451,0,6.754,1.071,6.907,1.493C69.953,40.169,67.651,41.24,63.2,41.24Z",
    transform: "translate(-25.705 -17.78)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.548,44.759h-5.8L8,41.831V36.978l3.038-2.886h5.514a.64.64,0,1,0,0-1.28H10.766a.668.668,0,0,0-.46.181L6.878,36.247a.789.789,0,0,0-.2.523V42.08a.631.631,0,0,0,.172.432L9.97,45.83a.666.666,0,0,0,.486.208h6.092a.64.64,0,1,0,0-1.28Z",
    transform: "translate(-3.61 -15.824)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.721,41.445h-.767c-.239,0-.384-.13-.384-.187s.145-.187.384-.187h1.919a.747.747,0,1,0,0-1.493H35.1a.768.768,0,0,0-1.535,0v.034a1.757,1.757,0,0,0-1.535,1.643,1.815,1.815,0,0,0,1.919,1.684h.767c.239,0,.384.13.384.187s-.145.187-.384.187H32.8a.747.747,0,1,0,0,1.493h.767a.768.768,0,0,0,1.535,0v-.034a1.757,1.757,0,0,0,1.535-1.643A1.815,1.815,0,0,0,34.721,41.445Z",
    transform: "translate(-15.263 -18.586)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAsset);
export default __webpack_public_path__ + "static/media/icon_asset.a6400c7d021696bbc53f1ee36a20d67b.svg";
export { ForwardRef as ReactComponent };